import { faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { InfMunCarregaInterface, infPercurso, SelectObjectRemoveInterface } from "../../../interfaces";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../app/store";
import {
    addListaMunicipiosCarregamento,
    removeListaMunicipioDescarregamentoTodos,
    removeMunicipioCarregamento,
    removeMunicipioCarregamentoTodos
} from "../../../features/manifestoSlice";
import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    ButtonRemover,
    ButtonTrash,
    JTable,
    JTBody,
    JTHead,
    JvCaption,

} from "../../../components/Components";
import { getUuidV4 } from "../../../utils/utils";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";

const initialFormMun: InfMunCarregaInterface = {
    id: 0,
    name: 'NATAL',
    municipio_id: 1161
}

const limite: number = 50;

export default function MunicipioCarrega(props: any) {
    const dispatch = useDispatch();
    const form = useSelector((state: RootState) => state.manifesto.manifesto);
    const selectMunicipios = useSelector((state: RootState) => state.manifesto.selectMunicipios);
    const listaMunicipiosCarregamento = useSelector((state: RootState) => state.manifesto.manifesto.infMunCarrega);
    const listaUfPercurso = useSelector((state: RootState) => state.manifesto.manifesto.infPercurso);
    const estadoInicialRef = props.estadoInicialRef;
    const [formMun, setFormMun] = useState<InfMunCarregaInterface>(initialFormMun);
    const { confirm, ConfirmModal } = useQuestion();
    const [saldo, setSaldo] = useState<number>(0);
    const { alertModal, ModalMessageEl } = useModalMessage();
    const [selecionado, setSelecionado] = useState<number | string>('');

    const validarPreenchimento = () => {
        if (estadoInicialRef.current) {
            const estadoInicial = estadoInicialRef.current.value || '';
            if (estadoInicial === "") {
                alertModal('Informe a UF Inicial');
                return false;
            }

            if (listaUfPercurso.find((estado: infPercurso) => estado.uf === estadoInicial)) {
                alertModal('Remova a UF Inicial de UF de percurso');
                return false;
            }
        }

        if (formMun.municipio_id.toString() === '0') {
            alertModal("Selecione um município")
            return false;
        }

        if (form.infMunCarrega.find((municipio: InfMunCarregaInterface) =>
            municipio.municipio_id === parseInt(formMun.municipio_id.toString()))) {
            alertModal("Município já adicionado")
            return false;
        }

        if (form.infMunCarrega.length === 50) {
            alertModal('Limite máximo de 50 locais de carregamento atingido.');
            return false;
        }

        if (form.indcarregaposterior) {
            if (form.infMunCarrega.length === 1) {
                alertModal('Em caso do Ind. Carrega. Posterior marcado, somente pode adicionar um município.');
                return false;
            }
        }
        return true;
    }

    const handleAdd = () => {
        if (validarPreenchimento()) {
            dispatch(addListaMunicipiosCarregamento({ ...formMun, id: getUuidV4() }));
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id);
        const confirmed = await confirm({
            title: "Confirmação",
            message: <>Deseja realmente remover <strong>{value.title}</strong> ?</>
        })

        if (confirmed) {
            dispatch(removeMunicipioCarregamento(value.id.toString()));
            if (form.indcarregaposterior) {
                dispatch(removeListaMunicipioDescarregamentoTodos());
            }
        }
        setSelecionado('');
    }

    const removerTudo = async () => {
        if (listaMunicipiosCarregamento.length > 0) {
            const confirmed = await confirm({
                title: "Confirmação",
                message: <>Remover todos ?</>
            })
            if (confirmed) {
                dispatch(removeMunicipioCarregamentoTodos());
            }
        }
    }

    useEffect(() => {
        const mun = selectMunicipios.find(item => item.capital === 1)
        if (mun) {

            setFormMun(
                {
                    ...formMun,
                    municipio_id: mun.id,
                    name: mun.name
                }
            )
        }
    }, [selectMunicipios])

    useEffect(() => {
        setSaldo(listaMunicipiosCarregamento.length);
    }, [listaMunicipiosCarregamento])

    return (<>
        <Card className="card-primary card-outline">
            <Card.Header className="fw-bold">
                <Card.Text>Municípios de carregamento</Card.Text>
            </Card.Header>
            <Card.Body className="">

                <Row className="g-2 mb-3">
                    <Col md>
                        <Form.Group controlId="municipio_carregamento">
                            <InputGroup>
                                <Form.Select value={formMun.municipio_id} name="municipio_carregamento"
                                    onChange={(e: any) => {
                                        setFormMun({
                                            ...formMun,
                                            municipio_id: parseInt(e.target.value),
                                            name: e.target.options[e.target.selectedIndex].text
                                        })
                                    }}>
                                    {selectMunicipios?.map((municipio: any) => (
                                        <option key={municipio.id}
                                            selected={municipio.capital.toString() === '1'}
                                            value={municipio.id}
                                        >
                                            {municipio.name}
                                        </option>
                                    ))}
                                </Form.Select>
                                <Button variant="primary" onClick={handleAdd} >
                                    <FontAwesomeIcon icon={faPlus} />
                                </Button>
                            </InputGroup>
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col md>
                        <JTable >
                            <JvCaption>({saldo} de {limite} no máximo)</JvCaption>
                            <JTHead>
                                <tr>
                                    <th className="text-center" style={{ width: '2.5rem' }}>
                                        <ButtonTrash onClick={() => removerTudo()} icon={faTrashAlt} />
                                    </th>
                                    <th>Município</th>
                                </tr>
                            </JTHead>
                            <JTBody>
                                {listaMunicipiosCarregamento?.map((item: InfMunCarregaInterface) => (
                                    <tr key={item.id}
                                        className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                                        <td className="text-center">
                                            <ButtonRemover
                                                onClick={
                                                    () => handleRemover({ id: item.id, title: item.name })
                                                }
                                            />
                                        </td>
                                        <td>{item.name}</td>
                                    </tr>
                                ))}
                            </JTBody>
                        </JTable>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
        {ConfirmModal}
        {ModalMessageEl}
    </>)
}
